import { Add } from "@material-ui/icons";
import React from "react";
import { NavLink } from "react-router-dom";
import { ReactComponent as Bird } from './bird.svg'
import s from './LinksForTables.module.scss'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux'

export const LinksForTables = ({ tableState }) => {
    const { is_staff } = useSelector(state => state.auth)

    const { t } = useTranslation()
    return (
        <>
            <div className={s.table__buttons}>
                <div className={s.buttons__container}>
                    <NavLink to='/collectiontable'>
                        <div style={tableState === 'collection' ? { color: '#FFFFFF' } : null}>
                            {t('collection')}
                        </div>
                    </NavLink>
                    {/* <NavLink to='/statisticstable'>
                        <div style={tableState === 'statistics' ? { color: '#FFFFFF' } : null}>
                            {t('statistics')}
                        </div>
                    </NavLink> */}
                    {is_staff && <NavLink to='/newfilestable'>
                        <div style={tableState === 'newFiles' ? { color: '#FFFFFF' } : null}>
                            {t('newFiles')}
                        </div>
                    </NavLink>}
                    {is_staff && <NavLink to='/deletetable'>
                        <div style={tableState === 'deleted' ? { color: '#FFFFFF' } : null}>
                            {t('deleted')}
                        </div>
                    </NavLink>}

                </div>
            </div>
            <NavLink to='/tableadd'>
                <div className={s.table__add}>
                    <Add className={s.icon_add} style={{ fontSize: '32' }} />
                    <span>{t('addNew')}</span>
                    <Bird width="32" height="32" />
                </div>
            </NavLink>
        </>
    )
}